/* ap-motion.js — lot M : révélation au défilement + profondeur. Cf. RAPPORT-LOT-M.md */
(function () {
  'use strict';
  var w = window, d = document;
  if (!w.matchMedia || !Element.prototype.closest) return;
  var on = !w.matchMedia('(prefers-reduced-motion: reduce)').matches &&
    !(w.Shopify && w.Shopify.designMode) && 'IntersectionObserver' in w;

  var SEL = '.ap-heading,.app-sec__title,.app-inside__title,.hp-proof__item,.hp-feat__item,' +
    '.hp-soft__card,.hp-ba__row,.hp-tier,.hp-everything,.hp-lib__cell,.hp-lib__all,' +
    '.hp-trust__item,.ap-card,.apg-item,.apr-summary,.apr-dist,.apr-card,.apt-track,' +
    '.apf-group,.apx-section,.apc-short,.apc-identity,.app-inside,.app-text,' +
    '.app-why__card,.app-who__list>li,.app-compat__table';

  var SKIP = '.app-gallery,.app-buy,.app-kit,.app-ladder,.app-units,.app-xsell,.app-sticky,' +
    '.app-zoom,.apr-dialog,[data-ap-drawer],dialog,#shopify-section-header,' +
    '#shopify-section-footer,#shopify-section-announcement-bar,#shopify-section-ap-cart-drawer';

  var pend = [], io = null, ts = 0, qd = false, hm = null, hi = null;

  function show(el) {
    var i = pend.indexOf(el);
    if (i > -1) pend.splice(i, 1);
    if (io) io.unobserve(el);
    el.classList.add('is-in');
    w.setTimeout(function () { el.style.willChange = 'auto'; }, 900);
  }

  function sweep() {
    var h = w.innerHeight * 1.06, n = pend.length < 48 ? pend.length : 48, hit = [], i;
    for (i = 0; i < n; i++) if (pend[i].getBoundingClientRect().top < h) hit.push(pend[i]);
    for (i = 0; i < hit.length; i++) show(hit[i]);
    ts = Date.now();
  }

  function collect(root) {
    var nodes = root.querySelectorAll(SEL), cand = [], i, el, r;
    for (i = 0; i < nodes.length; i++) {
      el = nodes[i];
      if (el.classList.contains('ap-reveal') || el.closest(SKIP)) continue;
      r = el.getBoundingClientRect();
      if (r.width && r.top > w.innerHeight) cand.push(el);
    }
    var last = null, k = 0;
    for (i = 0; i < cand.length; i++) {
      el = cand[i];
      if (el.closest('.ap-reveal')) continue;
      if (el.parentNode === last) k++; else { last = el.parentNode; k = 0; }
      if (k) el.style.setProperty('--ap-delay', (k > 5 ? 5 : k) * 60 + 'ms');
      el.classList.add('ap-reveal');
      pend.push(el);
      io.observe(el);
    }
  }

  function hero() {
    if (!hi) return;
    var r = hm.getBoundingClientRect();
    if (r.bottom < 0 || r.top > w.innerHeight) return;
    var p = (w.pageYOffset || d.documentElement.scrollTop || 0) / w.innerHeight;
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    if (p < 0.002) { hi.style.transform = ''; hi.style.willChange = 'auto'; return; }
    hi.style.willChange = 'transform';
    hi.style.transform = 'translate3d(0,' + (p * 10).toFixed(2) + 'px,0) scale(' +
      (1 + p * 0.05).toFixed(4) + ')';
  }

  function heroInit() {
    hm = hi = null;
    if (w.innerWidth < 768) return;
    var m = d.querySelector('[data-ap-hero] .hp-hero__media'), img = m && m.querySelector('img');
    if (img) { hm = m; hi = img; }
  }

  function frame() {
    qd = false;
    hero();
    if (pend.length && Date.now() - ts > 200) sweep();
  }

  function init() {
    if (!on) return;
    if (!io) io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) show(es[i].target);
    }, { rootMargin: '0px 0px 6% 0px', threshold: 0.12 });
    collect(d);
    heroInit();
    hero();
    ts = Date.now();
    w.setTimeout(sweep, 1200);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  w.addEventListener('scroll', function () {
    if (!qd) { qd = true; w.requestAnimationFrame(frame); }
  }, { passive: true });
  w.addEventListener('resize', function () {
    if (hi) hi.style.transform = '';
    heroInit();
    if (pend.length) sweep();
  }, { passive: true });
  d.addEventListener('shopify:section:load', function (e) {
    if (!on) return;
    collect(e.target && e.target.querySelectorAll ? e.target : d);
    heroInit();
    w.setTimeout(sweep, 400);
  });
})();
